/* Materparade: barra colore a tasselli distinti (uno per colore, niente gradiente).
   Trasforma i pulsanti .mp-pick in una fila di tasselli: si clicca un tassello (o si usa la tastiera).
   I pulsanti restano nel DOM (nascosti): la barra li "clicca", così sezione 3D e configuratore funzionano senza modifiche.
   Nella sezione 3D la barra sta nella colonna del testo, sotto la descrizione.
   Ordine: tre onde dal chiaro allo scuro; Bianco primo, Nero ultimo. */
(function () {
  'use strict';
  if (window.__mpBar) return;
  window.__mpBar = true;

  var ORDER = ['Bianco','Grigio perla','Rosa confetto','Rosa cipria','Pesca','Sabbia','Avorio','Giallo girasole','Giallo limone','Verde pistacchio','Verde salvia','Acquamarina','Azzurro cielo','Lavanda','Grigio pietra','Rosa antico','Rosso papavero','Corallo','Terracotta','Nocciola','Arancio ambra','Ocra','Oro antico','Verde oliva','Verde prato','Verde smeraldo','Turchese','Fucsia','Antracite','Bordeaux','Rosso melograno','Ruggine','Cioccolato','Verde bosco','Petrolio','Blu cobalto','Blu notte','Viola ametista','Melanzana','Nero'];

  function build(host) {
    if (host._mpBar) return;
    var btns = [].slice.call(host.querySelectorAll('.mp-pick'));
    if (btns.length < 2) return;
    var byName = {};
    btns.forEach(function (b) { byName[b.getAttribute('data-mp-color')] = b; });
    var seq = ORDER.map(function (n) { return byName[n]; }).filter(Boolean);
    btns.forEach(function (b) { if (seq.indexOf(b) < 0) seq.push(b); });
    var n = seq.length;

    var bar = document.createElement('div');
    bar.className = 'mp-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Colore della Mater');
    var name = document.createElement('p');
    name.className = 'mp-bar__name';
    name.setAttribute('aria-live', 'polite');
    var sw = document.createElement('div');
    sw.className = 'mp-bar__sw';
    sw.style.setProperty('--n', n);
    bar.appendChild(name);
    bar.appendChild(sw);

    var cur = -1;
    var tiles = seq.map(function (b, i) {
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'mp-sw';
      t.style.setProperty('--c', b.getAttribute('data-mp-hex'));
      t.setAttribute('aria-label', b.getAttribute('data-mp-color'));
      t.setAttribute('aria-pressed', 'false');
      t.addEventListener('click', function () { b.click(); });
      t.addEventListener('mouseenter', function () { name.textContent = b.getAttribute('data-mp-color'); });
      t.addEventListener('mouseleave', function () { name.textContent = cur >= 0 ? seq[cur].getAttribute('data-mp-color') : ''; });
      t.addEventListener('focus', function () { name.textContent = b.getAttribute('data-mp-color'); });
      sw.appendChild(t);
      return t;
    });

    function sync() {
      for (var i = 0; i < n; i++) {
        if (seq[i].getAttribute('aria-pressed') === 'true') {
          if (i !== cur) {
            if (cur >= 0) tiles[cur].setAttribute('aria-pressed', 'false');
            cur = i;
            tiles[i].setAttribute('aria-pressed', 'true');
            name.textContent = seq[i].getAttribute('data-mp-color');
          }
          return;
        }
      }
    }
    var mo = new MutationObserver(sync);
    btns.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['aria-pressed'] }); });

    host.classList.add('has-bar');
    host.insertBefore(bar, host.firstChild);
    host._mpBar = true;
    sync();
  }

  function init() {
    [].slice.call(document.querySelectorAll('.mp-vstep__picker, .mp-conf__colors, .mp-hero__picker')).forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
